<template>
  <div class="mobilenav">
    <ul class="mobilenav-menu">
      <li>
        <a v-if="isHome" href="#" v-scroll-to="'body'" @click="$emit('close')">
          {{ $t('topbar.home') }}
        </a>
        <router-link v-else :to="{ name: 'Home' }" @click="$emit('close')">
          {{ $t('topbar.home') }}
        </router-link>
      </li>
      <li>
        <a
          v-if="isHome"
          href="#"
          v-scroll-to="'.congratulations'"
          @click="$emit('close')"
        >
          {{ $t('topbar.graduates') }}
        </a>
        <router-link
          v-else
          :to="{ name: 'Home', hash: '#laureats' }"
          @click="$emit('close')"
        >
          {{ $t('topbar.graduates') }}
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'Login' }">{{
          $t('topbar.register')
        }}</router-link>
      </li>
      <li v-if="isLogged && isHome && 1 === 1">
        <router-link :to="{ name: 'Identity' }">
          {{ $t('register.topbar.edit') }}
        </router-link>
      </li>
      <li v-if="isLogged && !isHome && 1 === 1">
        <a href="#" @click.prevent="logout">
          {{ $t('register.topbar.logout') }}
        </a>
      </li>
    </ul>
    <div class="mobilenav-separator"></div>
    <ul class="mobilenav-menu">
      <li><a href="#" @click.prevent="changeLanguage('fr')">Français</a></li>
      <li><a href="#" @click.prevent="changeLanguage('de')">Deutsch</a></li>
    </ul>
    <div class="mobilenav-social">
      <a href="https://www.instagram.com/remisetitres.fr.ch" target="_blank">
        <v-icon color="#6eeebb" size="45">mdi-instagram</v-icon>
      </a>
    </div>
  </div>
</template>

<script>
import { Trans } from '@/plugins/i18n'

export default {
  computed: {
    isHome() {
      return this.$route.name === 'Home'
    },
    isLogged() {
      return this.$store.getters['auth/isLogged']
    }
  },
  methods: {
    changeLanguage(language) {
      Trans.changeLanguage(language)
      // this.$emit('close')
    },
    logout() {
      this.$store.dispatch('auth/logout').then(() => location.reload())
    }
  }
}
</script>

<style lang="scss">
.mobilenav {
  height: 100%;
  padding: 75px 20px 0 0;
  background: #000;
}

.mobilenav-menu {
  font-size: 30px;
  line-height: 1.2;
  list-style: none;
  text-align: right;

  a {
    color: #fff !important;
    text-decoration: none;
  }
}

.mobilenav-separator {
  display: flex;
  justify-content: flex-end;
  margin: 24px 0 18px;

  &::after {
    content: '';
    display: block;
    height: 2px;
    width: 50px;
    background: #ea3579;
  }
}

.mobilenav-social {
  display: flex;
  justify-content: flex-end;
  margin-top: 33px;

  a {
    text-decoration: none;
  }
}
</style>
